import { configureStore } from "@reduxjs/toolkit";
import { tripsReducer } from "./tripsSlice";
import { allTripsReducer } from "./allTripsSlice";

// Create and configure the Redux store
export const store = configureStore({
  reducer: {
    // Assign the flights state slice to the itinerariesReducer
    trips: tripsReducer,
    allTrips: allTripsReducer,
  },
});
